import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';

@Component({
  selector: 'mft-relatednews',
  templateUrl: "./relatednews.component.html"
})
export class RelatedNewsComponent implements OnInit, AfterViewInit {  
  @Input() blogsList: IBlog[];
  @Input() category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public blogService: BlogService,
  ) {

  }
  ngOnInit() {
    
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/relatednews.component.ts